import { PayloadAction } from "@reduxjs/toolkit";
import { ECommonDialogType } from "components/molecules/CommonDialog";
import { AlertHelper, DialogHelper } from "helpers";
import { EAlertType } from "helpers/alertHelper";
import { isEmpty } from "lodash";
import {
  IChangePasswordRequest,
  IGetAllWarehouseResponse,
  IGetByIdRequest,
  IGetCurrentUser,
  IPaginationRequest,
} from "model";
import { IApiResponse } from "model/Common/IApiResponse";
import {
  IAuthenticate,
  IAuthenticateRequest,
  IThirdPartyAuthenticationRequest,
} from "model/Identity/IAuthenticate";
import { call, put, takeEvery } from "redux-saga/effects";
import { IdentityActions } from "redux/actions";
import history from "routers/history";
import { UserApiService, WarehouseApiService } from "services";
import IdentityApiService from "services/IdentityApiService";
import { I18nTranslator, translations } from "utils/i18n";

function* authenticate(action: PayloadAction<IAuthenticateRequest>) {
  try {
    const result: IApiResponse<IAuthenticate> = yield call(
      IdentityApiService.login,
      action.payload
    );
    if (result.succeeded && result.data) {
      yield put(IdentityActions.authenticate.success(result.data));

      yield put(
        IdentityActions.getCurrentUser.request({
          id: result.data.id!,
        })
      );
    } else {
      yield put(IdentityActions.authenticate.failed(result));
    }
  } catch (error) {
    yield put(IdentityActions.authenticate.failed(error));
  }
}

function* pingAuthenticate(
  action: PayloadAction<IThirdPartyAuthenticationRequest>
) {
  try {
    const result: IApiResponse<IAuthenticate> = yield call(
      IdentityApiService.loginWithPing,
      action.payload
    );
    if (result.succeeded && result.data) {
      yield put(IdentityActions.pingAuthenticate.success(result.data));
      yield put(
        IdentityActions.getCurrentUser.request({
          id: result.data.id!,
        })
      );
    } else {
      yield put(IdentityActions.pingAuthenticate.failed(result));
      DialogHelper.open({
        type: ECommonDialogType.WARNING,
        title: I18nTranslator(translations.dialog.accountNotFound),
        message: !isEmpty(result.message)
          ? result.message[0].Text
          : !isEmpty(result.errors)
          ? result.errors
          : I18nTranslator(translations.errorMessage.unknownError),
        onConfirm: () => {
          window.location.reload();
          localStorage.clear();
          history.replace("/login");
        },
        isCancel: false,
      });
    }
  } catch (error) {
    yield put(IdentityActions.pingAuthenticate.failed(error));
  }
}

function* getAllWarehouse(action: PayloadAction<IPaginationRequest>) {
  try {
    const result: IGetAllWarehouseResponse = yield call(
      WarehouseApiService.getAllWarehouses,
      action.payload
    );
    if (result.succeeded && result.data) {
      const warehouses = result.data!;

      if (!isEmpty(warehouses)) {
        yield put(IdentityActions.getAllWarehouses.success(warehouses));
      } else {
        AlertHelper.showAlert(
          I18nTranslator(translations.login.noWarehouse),
          EAlertType.ERROR
        );
        yield put(IdentityActions.logout.request());
      }
    } else {
      yield put(IdentityActions.getAllWarehouses.failed(result));
    }
  } catch (error) {
    yield put(IdentityActions.getAllWarehouses.failed(error));
  }
}
function* getCurrentUser(action: PayloadAction<IGetByIdRequest>) {
  try {
    const result: IGetCurrentUser = yield call(
      UserApiService.getUserById,
      action.payload
    );
    if (result.succeeded && result.data) {
      yield put(IdentityActions.getCurrentUser.success(result.data!));
    } else {
      yield put(IdentityActions.getCurrentUser.failed(result));
    }
  } catch (error) {
    yield put(IdentityActions.getCurrentUser.failed(error));
  }
}
function* changePassword(action: PayloadAction<IChangePasswordRequest>) {
  try {
    const result: IGetCurrentUser = yield call(
      IdentityApiService.changePassword,
      action.payload
    );

    if (result.succeeded) {
      yield put(IdentityActions.changePassword.success(result.data!));
    } else {
      yield put(IdentityActions.changePassword.failed(result));
    }
  } catch (error) {
    yield put(IdentityActions.changePassword.failed(error));
  }
}

export function* Watcher() {
  yield takeEvery(IdentityActions.authenticate.request, authenticate);
  yield takeEvery(
    IdentityActions.pingAuthenticate.request,
    pingAuthenticate
  );
  yield takeEvery(IdentityActions.getAllWarehouses.request, getAllWarehouse);
  yield takeEvery(IdentityActions.getCurrentUser.request, getCurrentUser);
  yield takeEvery(IdentityActions.changePassword.request, changePassword);
}
